/**
 * The input's bitrate as the encoder sends it (DIAG-BITRATE-1): bitrate_kbps is the useful video and audio,
 * filler_kbps the CBR filler data the node strips on the way in (docs/bitrate-fill.md). The console shows their
 * sum, the number OBS shows in its stats; absent filler_kbps = none.
 */
export function wireKbps(i: { bitrate_kbps: number; filler_kbps?: number }): number {
  return i.bitrate_kbps + (i.filler_kbps ?? 0);
}
